import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaGooglePlay } from "react-icons/fa";
import { APP_THEME } from "../theme/theme";
import Header from "../components/header";

const redeemAmounts = [10, 50, 100, 250, 500, 1000];

function RedeemCodeRecharge() {
    const navigate = useNavigate();
    const [amount, setAmount] = useState("");
    const [error, setError] = useState("");
    const [parsedData, setParsedData] = useState(JSON.parse(localStorage.getItem("credentials")));

    const handlePay = () => {
        if (!amount || Number(amount) <= 0) {
            setError("Please select or enter amount");
            return;
        }

        navigate("/payment-confirmation", {
            state: {
                service: "Redeem Code Recharge",
                operator: 'Google Play Redeem Code',
                operator_id: '114',
                number: parsedData?.mobile || "",
                amount: amount,
                consumerName: parsedData?.name,
                serviceSpecificData: {
                    range: {
                        min_amount: '10',
                        max_amount: '3000'
                    },
                    form: {
                        param1: parsedData?.mobile || "9854777908"
                    }
                }
            }
        });
    };

    return (
        <>
            <Header title={"Redeem Code Recharge"} showBack={true} />
            <div className="p-4 flex flex-col min-h-[calc(100vh-140px)]">
                {/* Simple Google Play Card */}
                <div className="flex items-center gap-3 mb-6 p-3.5 px-4 rounded-xl border"
                    style={{
                        background: APP_THEME.surfaceColor,
                        borderColor: APP_THEME.borderColor,
                    }}
                >
                    <img
                        src='https://rechargemyphone.in/app-v3/assets/playstore.png'
                        alt='Google Play'
                        className="w-11 h-11 rounded-xl object-cover flex-shrink-0"
                        onError={(e) => {
                            e.target.style.display = 'none';
                            if (e.target.nextSibling) {
                                e.target.nextSibling.style.display = 'flex';
                            }
                        }}
                    />
                    <div className="flex-1">
                        <div className="text-[15px] font-bold" style={{ color: APP_THEME.textPrimary, fontFamily: APP_THEME.fontFamily }}>
                            Google Play
                        </div>
                        <div className="text-xs" style={{ color: APP_THEME.textSecondary, fontFamily: APP_THEME.fontFamily }}>
                            Redeem Code
                        </div>
                    </div>
                </div>

                {/* Amount Selection */}
                <div className="mb-6">
                    <label
                        className="block text-sm font-semibold mb-3"
                        style={{ color: APP_THEME.textPrimary, fontFamily: APP_THEME.fontFamily }}
                    >
                        Select Amount
                    </label>

                    {/* Amount Grid */}
                    <div className="grid grid-cols-3 gap-2.5 mb-4">
                        {redeemAmounts.map((amt) => (
                            <button
                                key={amt}
                                onClick={() => { setAmount(String(amt)); setError(""); }}
                                className="p-3 rounded-xl text-[15px] font-bold cursor-pointer transition-all duration-200 active:scale-95"
                                style={{
                                    border: `1.5px solid ${Number(amount) === amt ? APP_THEME.primaryColor : APP_THEME.borderColor}`,
                                    background: Number(amount) === amt ? APP_THEME.primaryLight : APP_THEME.surfaceColor,
                                    color: Number(amount) === amt ? APP_THEME.primaryColor : APP_THEME.textPrimary,
                                    fontFamily: APP_THEME.fontFamily,
                                }}
                            >
                                ₹{amt}
                            </button>
                        ))}
                    </div>

                    {/* Custom Amount Input */}
                    <input
                        type="number"
                        placeholder="Or enter custom amount"
                        value={amount}
                        onChange={(e) => { setAmount(e.target.value); setError(""); }}
                        className="w-full p-3.5 rounded-xl text-[15px] font-semibold outline-none transition-colors duration-200"
                        style={{
                            border: `1px solid ${error ? APP_THEME.errorColor : APP_THEME.borderColor}`,
                            background: APP_THEME.surfaceColor,
                            color: APP_THEME.textPrimary,
                            fontFamily: APP_THEME.fontFamily,
                        }}
                        onFocus={(e) => (e.target.style.borderColor = APP_THEME.primaryColor)}
                        onBlur={(e) => (e.target.style.borderColor = APP_THEME.borderColor)}
                    />

                    {error && (
                        <div
                            className="text-xs mt-2"
                            style={{ color: APP_THEME.errorColor, fontFamily: APP_THEME.fontFamily }}
                        >
                            {error}
                        </div>
                    )}
                </div>

                {/* Buy Button */}
                <button
                    onClick={handlePay}

                    className="w-full py-3.5 rounded-lg text-base font-semibold flex items-center justify-center gap-2 transition-all duration-200 active:scale-98 disabled:opacity-70 disabled:cursor-not-allowed"
                    style={{
                        background: APP_THEME.primaryColor,
                        color: APP_THEME.textOnPrimary,
                        borderRadius: APP_THEME.borderRadiusBtn,
                        fontFamily: APP_THEME.fontFamily,
                    }}
                >
                    Buy Recharge Code
                </button>
            </div>

            <style>
                {`
                    .active\\:scale-98:active {
                        transform: scale(0.98);
                    }
                    .active\\:scale-95:active {
                        transform: scale(0.95);
                    }
                `}
            </style>
        </>
    );
}

export default RedeemCodeRecharge;